/* eslint-disable react/prop-types */

import { useState, useEffect } from "react"
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"
import { X } from "lucide-react"

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 0;
  }
`

const ModalContent = styled(motion.div)`
  background-color: #2A2B2E;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  height: auto;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #3A3B3E;
`

const ModalTitle = styled.h2`
  color: #fff;
  margin: 0;
  font-size: 1.5rem;
`

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 1.5rem;
`

const FormContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #2A2B2E;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #4A4B4F;
    border-radius: 4px;
  }
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.label`
  color: #fff;
  font-size: 0.9rem;
`

const Input = styled.input`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #3A3B3E;
  color: white;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`

const Select = styled.select`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #3A3B3E;
  color: white;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`

const Button = styled.button`
  padding: 12px 20px;
  border-radius: 4px;
  border: none;
  background-color: #4A88F3;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #3B78E0;
  }

  &:disabled {
    background-color: #4A4B4F;
    cursor: not-allowed;
  }
`

export const InventoryModal = ({ isOpen, onClose, onSave, item, products }) => {
  const [formData, setFormData] = useState({
    productid: "",
    color: "",
    talla: "",
    quantity: 0,
    status: 1,
  })

  const [tallas, setTallas] = useState([])
  const [colors, setColors] = useState([])
  const [color, setColor] = useState()
  const [value, setValue] = useState(null)
  useEffect(() => {
    if (item) {
      setValue(item.productid)
      setFormData(item)
      const selectedProduct = products.find((p) => p.id == item.productid)
      setColors(JSON.parse(selectedProduct?.colores))
      setTallas(JSON.parse(selectedProduct?.tallas))
      setColor(item.color)
    } else {
      
      setFormData({
        productid: "",
        color: "",
        talla: "",
        quantity: 0,
        status: 1,
      })
    }
  }, [item])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: name === "stock" ? Number.parseInt(value) : value,
    }))

    if (name === "productid") {
      const selectedProduct = products.find((p) => p.id == value)
      if (selectedProduct) {
        console.log(JSON.parse(selectedProduct?.tallas))
        setColors(JSON.parse(selectedProduct?.colores))
        setTallas(JSON.parse(selectedProduct?.tallas))
        setFormData((prev) => ({
          ...prev,
          productName: selectedProduct.nombre,
        }))
      }
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    onSave(formData)
  }



  return (
    <AnimatePresence>
      {isOpen && (
        <ModalOverlay initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}>
          <ModalContent
            onClick={(e) => e.stopPropagation()}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", damping: 20, stiffness: 300 }}
          >
            <ModalHeader>
              <ModalTitle>{item ? "Editar Inventario" : "Añadir Inventario"}</ModalTitle>
              <CloseButton onClick={onClose}>
                <X size={24} />
              </CloseButton>
            </ModalHeader>
            <FormContainer>
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label htmlFor="productId">Producto</Label>
                  <Select id="productid" name="productid" value={formData.productid} onChange={handleChange} required>
                    <option value="">Seleccionar producto</option>
                    {products.map((product) => (
                      <option key={product.id} value={product.id}>
                        {product?.nombre}
                      </option>
                    ))}
                  </Select>
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="color">Color</Label>
                <div style={{display: 'flex', gap: '10px'}}>
                  {colors?.map((colorD, index) => (
                        <div key={index} style={{backgroundColor: colorD, width: '30px', height: '30px', borderRadius: '50%', cursor: "pointer", boxShadow: colorD == color ? "0 4px 12px 0 rgba(127, 255, 212, 0.6" : "none"}} onClick={() => {setColor(colorD);  setFormData((prev) => ({
                          ...prev,
                           color: colorD,
                        })) }}>

                        </div>
                  ))}
                </div>
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="talla">Talla</Label>
                  <Select id="talla" name="talla" value={formData.talla} onChange={handleChange} required>
                    <option value="">Seleccionar producto</option>
                     {tallas?.map((talla) => (
                        <option key={talla.id} value={talla.id}>
                            {talla?.name}
                        </option>
                    ))}
                  </Select>
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="quantity">Stock</Label>
                  <Input
                    id="quantity"
                    name="quantity"
                    type="number"
                    value={formData.quantity}
                    onChange={handleChange}
                    required
                    min="0"
                  />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="status">Estado</Label>
                  <Select
                    id="status"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    required
                  >
                    <option value="1">Activo</option>
                    <option value="0">Inactivo</option>
                  </Select>
                </FormGroup>
                <Button type="submit">{item ? "Guardar cambios" : "Añadir inventario"}</Button>
              </Form>
            </FormContainer>
          </ModalContent>
        </ModalOverlay>
      )}
    </AnimatePresence>
  )
}

